import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import BestBabyFormulaLawyersWrapper from "@components/layouts/bestbabyformulalawyersWrapper";
import MainBanner from "@components/bestbabyformulalawyers/mainBanner";

const OffersList = dynamic(() => import("@components/shared/offersList"));
const Lawsuits = dynamic(
    () => import("@components/bestbabyformulalawyers/lawsuits"),
);
const Parkinson = dynamic(
    () => import("@components/bestbabyformulalawyers/parkinson"),
);
const SideEffects = dynamic(
    () => import("@components/bestbabyformulalawyers/sideEffects"),
);

export default function BestBabyFormulaLawyersHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <BestBabyFormulaLawyersWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Lawsuits />
            <Parkinson />
            <SideEffects />
        </BestBabyFormulaLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
